<app-protected-information *ngIf="this.configurationService.application.enablePrivacyAct && !this.isAmericanCitizen(this.application)"></app-protected-information>
<form #form="ngForm" (ngSubmit)="form.form.valid && onSubmit()" novalidate>
  <div class="row mt-3">
    <div class="col-12 col-md-4">
      <div class="form-group">
        <label>{{ "onboarding.additional-identification.id-type" | translate: {Default:"Tipo de identificación"} }}</label>
        <select class="form-control custom-select" name="idType" [(ngModel)]="application.body.identificationType" #idType="ngModel" [ngClass]="inputFieldCss(idType, form)" required>
          <option [ngValue]="null">{{ "onboarding.additional-identification.select" | translate: {Default:"Selecciona..."} }}</option>
          <option *ngFor="let id of ids" [ngValue]="id.id">{{id.value}}</option>
        </select>
        <app-field-error-display [control]="idType" [form]="form"></app-field-error-display>
      </div>
    </div>

    <div *ngIf="idType.value === 'ITIN_LETTER'" class="col-12 col-md-6">
      <div class="form-group">
        <label for="itin">ITIN</label>
        <input type="text" class="form-control" id="itin" name="itin" [(ngModel)]="application.body.fiscalIdentifier" #itin="ngModel" [ngClass]="inputFieldCss(itin, form)" required>
        <app-field-error-display [control]="itin" [form]="form"></app-field-error-display>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="form-group">
        <label>{{ "onboarding.additional-identification.country-issue" | translate: {Default:"País de emisión"} }}</label>
        <input id="commercialActivity" type="text"
               name="commercialActivityId"
               class="form-control"
               placeholder="{{this.translate.instant('onboarding.additional-identification.identificationCountry_select', {Default:  'Escribe el país de emisión'})}}"
               [(ngModel)]="selectedCountry"
               [ngbTypeahead]="searchIdentificationCountry"
               (focus)="focusIdentificationCountry$.next($any($event).target.value)"
               (click)="clickIdentificationCountry$.next($any($event).target.value)"
               [resultFormatter]="itemToString"
               [inputFormatter]="itemToString"
               [editable]="false"
               (ngModelChange)="assignCountry()"
               #instanceIdentificationCountry="ngbTypeahead"
               #identificationCountry="ngModel"
               not-null
               [ngClass]="inputFieldCss(identificationCountry, form)"
        />
        <app-field-error-display [control]="identificationCountry" [form]="form"></app-field-error-display>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="form-group">
        <label>{{ "onboarding.additional-identification.id-number" | translate: {Default:"No. identificación"} }}</label>
        <input type="text" class="form-control" name="idNumber" [(ngModel)]="application.body.identificationNumber" #idNumber="ngModel" [ngClass]="inputFieldCss(idNumber, form)" required app-addressNumber >
        <app-field-error-display [control]="idNumber" [form]="form"></app-field-error-display>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="form-group">
        <label>{{ "onboarding.additional-identification.emission" | translate: {Default:"Emisión"} }}</label>
        <div class="input-group">
          <select class="form-control custom-select" name="emissionDate" [(ngModel)]="application.body.identificationEmissionDate" #emissionDate="ngModel" [ngClass]="inputFieldCss(emissionDate, form)" [required]="expirationDate.value" required>
            <option [ngValue]="null">{{ "onboarding.additional-identification.select" | translate: {Default:"Selecciona..."} }}</option>
            <option *ngFor="let year of issuingYears" [ngValue]="year">{{year}}</option>
          </select>
        </div>
        <app-field-error-display [control]="emissionDate" [form]="form"></app-field-error-display>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="form-group">
        <label>{{ "onboarding.additional-identification.expiration" | translate: {Default:"Expiración"} }}</label>
        <div class="input-group">
          <select class="form-control custom-select" name="expirationDate" [(ngModel)]="application.body.identificationExpirationDate" #expirationDate="ngModel" [ngClass]="inputFieldCss(expirationDate, form)" [required]="emissionDate.value" required >
            <option [ngValue]="null">{{ "onboarding.additional-identification.select" | translate: {Default:"Selecciona..."} }}</option>
            <option *ngFor="let year of expirationYears" [ngValue]="year">{{year}}</option>
          </select>
        </div>
        <app-field-error-display [control]="expirationDate" [form]="form"></app-field-error-display>
      </div>
    </div>
  </div>
  <div class="col-12 text-right">
    <button class="btn btn-primary" type="submit" [disabled]="!application.body.identificationEmissionDate || !application.body.identificationExpirationDate || !application.body.identificationType || !application.body.identificationCountry || !application.body.identificationNumber">{{ "onboarding.additional-identification.continue" | translate: {Default:"Continuar"} }}</button>
  </div>
</form>
